import { GoogleLoginRepository as GoogleLoginBaseRepository } from '@bingads-webui/google-login-repository';
import { getClientId } from './gtm-app-cohort-provider';

const SCOPE = 'https://www.googleapis.com/auth/tagmanager.edit.containers https://www.googleapis.com/auth/tagmanager.edit.containerversions https://www.googleapis.com/auth/tagmanager.publish https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile';

export class GoogleLoginRepository extends GoogleLoginBaseRepository {
  constructor({ deps }) {
    const { google, GSILocal, permissions } = deps;
    super({
      scope: SCOPE,
      clientId: getClientId(document.domain, permissions.IsGTMMultiAppSupportEnabled),
      GSILocal,
      google,
    });
  }
}
